import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
    return localStorage.getItem("token");
  };
export const getAllZoneWiseReport = async (startDate,endDate,vehicleType,ownerType) => {
  const ownerId = ownerType === null ? '' : ownerType;
  // const loadingId = LoadingEquipmentId === null ? '' : LoadingEquipmentId;
  const vehicleId = vehicleType === null ? '' : vehicleType;
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `SCVReport/SCVTripToTransferStationZoneWise?StartDate=${startDate}&EndDate=${endDate}&VehicleTypeId=${vehicleId}&OwnerTypeId=${ownerId}`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        
        return response;
    } catch (error) {
        throw error
    }
};

export const getAllCircleWiseReportCircle = async ( StartDate,EndDate,zoneId,vehicleType,ownerType,) => {
  const ownerId = ownerType == null ? '' : ownerType;
  // const loadingId = LoadingEquipmentId === null ? '' : LoadingEquipmentId;
  const vehicleId = vehicleType == null ? '' : vehicleType;
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `SCVReport/SCVTripToTransferStationCircleWise?StartDate=${StartDate}&EndDate=${EndDate}&ZoneId=${zoneId}&VehicleTypeId=${vehicleId}&OwnerTypeId=${ownerId}`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};